import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDigitalVsNonDigitalAffinity } from '../../../../redux/thunks/affinityHubThunk';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { ButterflyChart } from '../../../shared';

const DigitalVsNonDigitalAffinity = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const { digitalVsNonDigital } = useSelector(state => state.affinityHub)
    const { seriesData, categories, isLoading } = digitalVsNonDigital;

    useEffect(()=> {
        dispatch(getDigitalVsNonDigitalAffinity());
    }, []);

    return (
        <Box className="box-sizing-border-box border-1-gray br-16px">
            <Box className="flex-row-space-between padding-24px border-bottom-gray">
                <Box className="flex-column">
                    <Typography className="text-md-semi-bold gray-900">
                        Broad Affinity
                    </Typography>
                </Box>
            </Box>
            <Grid container>
                <Grid item xs={12} className="flex-column-content-center">
                    <Box className="padding-tb-0-rl-9 w-100">
                        {isLoading ? <Skeleton height={340} /> : <ButterflyChart 
                            categories={categories} 
                            seriesData={seriesData}
                        />}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DigitalVsNonDigitalAffinity;
